/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_6_TitleInputs */

const en_mk_loop_6_title = /** @type {(inputs: Mk_Loop_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkpoint & waves`)
};

const id_mk_loop_6_title = /** @type {(inputs: Mk_Loop_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkpoint & gelombang`)
};

/**
* | output |
* | --- |
* | "Checkpoint & waves" |
*
* @param {Mk_Loop_6_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_6_title = /** @type {((inputs?: Mk_Loop_6_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_6_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_6_title(inputs)
	return en_mk_loop_6_title(inputs)
});